import getBetweenByOneDate from '../../../../../../helpers/filters/get-between-by-one-date'
import { Filters } from '../../../../../../types/strapi/strapi'
import FormValues from '../components/filters-form/types/form-values'

const toStatusFilter = (status: string | string[]) =>
    Array.isArray(status) ? { $in: status } : { $eq: status }

export const buildFilters = (formValues: Partial<FormValues> = {}): Filters => {
    const {
        receiptStatus,
        createdAt,
        materialTypeDocId,
        materialWidth,
        amount,
        initiatorDocId,
        supplierDocId,
    } = formValues

    const filters: Filters = {
        ...(receiptStatus ? { receiptStatus: toStatusFilter(receiptStatus) } : {}),
        ...(createdAt ? { createdAt: getBetweenByOneDate(createdAt) } : {}),
        ...(supplierDocId ? { supplier: { documentId: { $eq: supplierDocId } } } : {}),
    }

    const positionFilters: Record<string, unknown> = {}
    const materialFilters: Record<string, unknown> = {}

    if (materialTypeDocId) {
        materialFilters.material_type = { documentId: { $eq: materialTypeDocId } }
    }

    if (materialWidth != null && materialWidth !== '') {
        const width = Number(materialWidth)
        if (!Number.isNaN(width)) {
            materialFilters.width = { $eq: width }
        }
    }

    if (Object.keys(materialFilters).length > 0) {
        positionFilters.material = materialFilters
    }

    if (amount != null && amount !== '') {
        const amountNum = Number(amount)
        if (!Number.isNaN(amountNum)) {
            positionFilters.amount = { $eq: amountNum }
        }
    }

    if (initiatorDocId) {
        positionFilters.initiator = { documentId: { $eq: initiatorDocId } }
    }

    if (Object.keys(positionFilters).length > 0) {
        return {
            ...filters,
            receipt_positions: positionFilters,
        }
    }

    return filters
}
